import { gql } from 'react-apollo';

export const getUserByEmail = gql`
  query getUserByEmail($email: String!) {
    user: user_by_email(email: $email) {
      id
      name
      email
      type
      church {
        id
        name
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/settings/queries/getUserByEmail.js